import React, { useEffect, useState } from 'react';

const AgePopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const storageKey = 'age_ack';

  useEffect(() => {
    // Komponent yüklənəndə localStorage yoxlanılır
    const isAcknowledged = localStorage.getItem(storageKey);
    if (!isAcknowledged) {
      setIsOpen(true);
      // Popup açılanda body-də scroll-u bağlamaq olar (istəyə bağlı)
      document.body.style.overflow = 'hidden';
    }
  }, []);

  const handleUnderstand = () => {
    localStorage.setItem(storageKey, '1');
    setIsOpen(false);
    // Modal bağlandıqda scroll-u bərpa edirik
    document.body.style.overflow = 'unset';
  };

  // Əgər istifadəçi artıq təsdiqləyibsə, heç nə göstərmə
  if (!isOpen) return null;

  return (
    <div className={`age-popup ${isOpen ? 'age-popup--open' : ''}`} aria-hidden={!isOpen}>
      {/* Overlay */}
      <div 
        className="age-overlay" 
        id="age-overlay" 
        style={{ display: 'block' }} 
        aria-hidden={!isOpen}
      ></div>

      {/* Modal */}
      <div 
        className="age-modal" 
        id="age-modal" 
        style={{ display: 'flex' }} 
        role="dialog" 
        aria-modal="true" 
        aria-label="Age notice"
        aria-hidden={!isOpen}
      >
        <div className="age-modal__content age-popup__panel">
          <h3>18+ ONLY</h3>
          <p className="age-popup__text">
            18+ ONLY • VIRTUAL CREDITS • NO CASH VALUE
          </p>
          <div className="age-modal__actions">
            <button 
              type="button" 
              className="age-modal__btn age-popup__btn"
              onClick={handleUnderstand}
            >
              I UNDERSTAND
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgePopup;